import styled from 'styled-components';
import COLORS from '../../common/styles/color-pallete';
import { FONT_FAMILY } from '../../common/styles/fontStyles';

export const LabelTextWrapper = styled.div`
  @media screen and (max-width: 1080px) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

export const LabelTextCash = styled.div`
  font-family: ${FONT_FAMILY.hellix.regular};
  font-size: 14px;
  line-height: 1.43;
  letter-spacing: normal;
  color: ${COLORS.textLightGrey};
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  padding-left: 10px;
  padding-top: ${({ paddingTop }) => (paddingTop ? paddingTop : '10px;')};

  span {
    color: '${COLORS.darkBlue}';
    cursor: pointer;
    text-decoration: underline;
    a {
      color: ${COLORS.aqua};
    }
  }
`;
